import { getI18nCookieData, setI18nCookieData } from '../modules/i18n';

document.addEventListener('jb-cookie-consent:connected', (event: Event) => {
  const { element } = (event as CustomEvent).detail;
  const { country, languageIso2 } = getI18nCookieData();
  element.country = country || undefined;
  element.currentLanguageIso2 = languageIso2 || undefined;
});

document.addEventListener('jb-cookie-consent:language-changed', (event: Event) => {
  const { languageIso2 } = (event as CustomEvent).detail;
  const { region, country, language, market } = getI18nCookieData();
  setI18nCookieData({ region, country, language, languageIso2, market });
});
